import * as Si from "react-icons/si";

import {
  FaJava,
  FaHtml5,
  FaCss3Alt,
  FaAngular,
  FaDocker,
  FaAws,
  FaGitAlt,
  FaGithub,
} from "react-icons/fa";

import {
  Database,
  GitBranch,
  Network,
  LineChart,
  Workflow,
  Code,
  Cpu,
  Box,
  Server,
  Cloud,
  ShieldCheck,
  KeyRound,
  Layers,
} from "lucide-react";

const LUCIDE = {
  LucideDatabase: Database,
  LucideGitBranch: GitBranch,
  LucideNetwork: Network,
  LucideLineChart: LineChart,
  LucideWorkflow: Workflow,
  LucideCode2: Code,
  LucideCpu: Cpu,
  LucideBox: Box,
  LucideServer: Server,
  LucideCloud: Cloud,
  LucideShieldCheck: ShieldCheck,
  LucideKeyRound: KeyRound,
  LucideLayers: Layers,
};

const customIcons = {
  Java: FaJava,
  SpringBoot: Si.SiSpringboot,
  SpringMVC: Si.SiSpringboot,
  SpringDataJPA: Layers,
  SpringSecurity: ShieldCheck,
  Hibernate: Si.SiHibernate,
  RESTfulAPIs: Network,
  Microservices: Code,
  JWTAuthentication: KeyRound,

  HTML5: FaHtml5,
  CSS3: FaCss3Alt,
  JavaScript: Si.SiJavascript,
  TypeScript: Si.SiTypescript,
  Angular: FaAngular,

  SQL: Database,
  Oracle: Database,
  MySQL: Si.SiMysql,
  MongoDB: Si.SiMongodb,
  Redis: Si.SiRedis,

  Docker: FaDocker,
  Kubernetes: Si.SiKubernetes,
  AWS: FaAws,
  Jenkins: Si.SiJenkins,

  Maven: Si.SiApachemaven,
  Gradle: Si.SiGradle,
  JUnit: Si.SiJunit5,
  Postman: Si.SiPostman,
  Swagger: Si.SiSwagger,
  Git: FaGitAlt,
  GitHub: FaGithub,
  SonarQube: Si.SiSonarqubeserver,
  IntelliJ: Si.SiIntellijidea,
  Eclipse: Si.SiEclipseide,
};

export function resolveIcon(iconKey) {
  if (!iconKey) return Code;

  if (customIcons[iconKey]) {
    return customIcons[iconKey];
  }

  if (LUCIDE[iconKey]) {
    return LUCIDE[iconKey];
  }

  if (Si[iconKey]) {
    return Si[iconKey];
  }

  return Code;
}

export const ICON_OPTIONS = [
  "Java",
  "JavaScript",
  "TypeScript",
  "HTML5",
  "CSS3",
  "Angular",

  "SpringBoot",
  "SpringMVC",
  "SpringDataJPA",
  "SpringSecurity",
  "Hibernate",
  "RESTfulAPIs",
  "Microservices",
  "JWTAuthentication",

  "SQL",
  "Oracle",
  "MySQL",
  "MongoDB",
  "Redis",

  "Docker",
  "Kubernetes",
  "AWS",
  "Jenkins",

  "Maven",
  "Gradle",
  "JUnit",
  "Postman",
  "Swagger",
  "Git",
  "GitHub",
  "SonarQube",
  "IntelliJ",
  "Eclipse",

  "SiPython",
  "SiReact",
  "SiSpringboot",
  "SiMysql",
  "SiMongodb",
  "SiRedis",
  "SiJavascript",
  "SiTypescript",
  "SiHtml5",
  "SiCss",
  "SiAngular",
  "SiDocker",
  "SiKubernetes",
  "SiGithub",
  "SiJenkins",
  "SiApachemaven",
  "SiGradle",
  "SiJunit5",
  "SiPostman",
  "SiSwagger",

  "LucideDatabase",
  "LucideGitBranch",
  "LucideNetwork",
  "LucideLineChart",
  "LucideWorkflow",
  "LucideCode2",
  "LucideCpu",
  "LucideBox",
  "LucideServer",
  "LucideCloud",
  "LucideShieldCheck",
  "LucideKeyRound",
  "LucideLayers",
];